
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.635 4.758c-.591-.986-2.218-1.923-4.092-1.923-2.416 0-3.574 1.01-3.574 2.293 0 1.503 1.775 1.922 3.845 2.169 3.6.443 6.952 1.38 6.952 5.497 0 3.846-3.402 5.497-7.247 5.497-3.526 0-6.237-1.085-7.519-4.24l2.712-1.405c.764 1.898 2.76 2.736 4.856 2.736 2.046 0 3.969-.714 3.969-2.588 0-1.627-1.701-2.292-3.994-2.539C4.018 9.835.764 8.899.764 5.029c0-3.55 3.5-5.004 6.68-5.029 2.688 0 5.473.764 6.78 3.427l-2.589 1.33zM34.19 8.998c.025 1.972-.493 4.018-1.602 5.62l2.046 2.022-2.292 2.292-2.096-2.07c-1.306.838-2.958 1.281-4.905 1.281-6.139 0-8.85-4.462-8.875-8.948-.025-4.511 2.81-9.023 8.874-9.023 6.065 0 8.776 4.388 8.85 8.826zm-14.52.27c.05 2.836 1.924 5.868 5.67 5.868 3.895 0 5.769-3.279 5.646-6.237-.123-2.785-1.578-5.793-5.646-5.793-4.067 0-5.718 3.254-5.67 6.163zM39.81.592V14.84h8.874v3.008H36.556V.592h3.254z","fill":"#fff"}})])
          )
        }
      }
    